export default __webpack_public_path__ + "static/media/hair-clear-spring.fae33d0e.png";